import tzExclusions from './tz-exclusions';

/**
 * @ngdoc service
 * @name gazelle.components.time.service:$gzTime
 *
 * @description
 * The $gzTime service provides a service to deal with moment/time related functionality.
 */
export const name = '$gzTime';
export default function $gzTime($log, rnHttp, rnPreferences, moment, $q) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const PORTAL_SERVICE_NAME = 'portal_service';
  const service = {
    getTimeZones,
    getTimeZonesSync,
    getTimeZoneDisplay,
    getPreferredTimeZone,
    getByOffset,
    getById,
  };

  return service;

  /**
   * Gets time zones wrapped in a promise for legacy reasons (this call used to request a list of zones from a service)
   */
  function getTimeZones() {
    return $q.resolve(getTimeZonesSync());
  }

  /**
   * Gets time zones synchronously sorted by UTC offset and then name
   */
  function getTimeZonesSync() {
    let zones = moment.tz.names()
      .filter(timeZoneId => !tzExclusions.includes(timeZoneId))
      .map(timeZoneId => getById(timeZoneId));
    return sort(zones);
  }

  function getTimeZoneDisplay(timezone) {
    return moment.tz(timezone.value).format('(UTCZ)') + ' ' + timezone.value.replace(/_/g, ' ');
  }

  function sort(timezones) {
    let sortingFns= [];
    sortingFns.push(timezone => {
      return moment.tz(timezone.value).utcOffset();
    });

    sortingFns.push(timezone => {
      return timezone.value.toLowerCase();
    });

    return _.sortByAll(timezones, sortingFns);
  }

  function getPreferredTimeZone() {
    return rnPreferences.getAll().then(prefs => {
      let timeZone = _.get(prefs, 'general.timeZone', moment.tz.guess());
      return timeZone;
    });
  }

  function getByOffset(offset) {
    return getTimeZones().then(zones => {
      return _.filter(zones, zone => {
        return moment.tz(zone.value).utcOffset() === offset;
      });
    });
  }

  function getById(timeZoneId) {
    let tz =  {
      value: timeZoneId.trim(),
    };

    tz.display = getTimeZoneDisplay(tz);
    return tz;
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/time/time.service.js